import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { DlgResourceOrdersComponent } from '../dlg-resource-orders/dlg-resource-orders.component';
import { default as RESOURCES } from '../resource';

@Component({
    selector: 'app-market-resource-orders',
    templateUrl: './resource-orders.component.pug',
    styleUrls: ['./resource-orders.component.less']
})
export class ResourceOrdersComponent implements OnInit, OnDestroy {

    private _route$;
    private _isClosed = true;

    private _dialogRef: MatDialogRef<DlgResourceOrdersComponent>;

    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _dialog: MatDialog
    ) {
    }

    ngOnInit() {
        let resourceChanged;
        let prevResourceType;

        this._route$ = this._route.params
            .subscribe((params) => {
                const { shard, resourceType } = this._route.snapshot.params;
                const data = this._route.snapshot.data['data'];

                resourceChanged = false;
                if (resourceType !== prevResourceType) {
                    resourceChanged = true;
                }
                prevResourceType = resourceType;

                if (!this._isClosed && resourceChanged) {
                    this._dialogRef.afterClosed()
                        .subscribe(() => {
                            this.showDialog(data, shard, resourceType);
                        });

                    return;
                }

                if (!resourceChanged) {
                    return;
                }

                this.showDialog(data, shard, resourceType);
            });
    }

    ngOnDestroy() {
        this._route$.unsubscribe();
        this._dialogRef.close();
    }

    showDialog(lists, shard, resourceType): void {
        const type = RESOURCES[resourceType].type;

        this._isClosed = false;
        this._dialogRef = this._dialog
            .open(DlgResourceOrdersComponent, {
                backdropClass: 'mat-backdrop--long-scroll',
                panelClass: ['mat-dialog--wide', 'mat-dialog--long-scroll', `dlg-resource--${ type }`],
                data: {
                    shard,
                    resourceType,
                    ...lists
                }
            });

        this._dialogRef.afterClosed().subscribe(() => {
            this._isClosed = true;
            try {
                const matchResourceType = location.hash.match(/market\/all(?:\/.+)?(?:\/)(.+)/)[1];

                if (matchResourceType === resourceType) {
                    this._router.navigate(['/market/all']);
                }
            } catch (ignore) {
                // Noop.
            }
        });
    }

}
